<template>
    <div>
        <orden-view @load-orden="loadOrden"></orden-view>
        <br />
        <div class="nj-view-container">
            <div class="nj-flx">
                <button class="nj-button c-green" v-if="pagar" @click="pagarOrden"><i class="mdi-content-save"></i>Pagar</button>
                <button class="nj-button c-green" v-if="contabilizar" @click="contableOrden"><i class="mdi-content-save"></i>Aprobación Contable</button>
                <button class="nj-button c-green" v-if="aprobar" @click="aprobarOrden"><i class="mdi-content-save"></i>Aprobar</button>
                <button class="nj-button" @click="listarPendientes"><i class="mdi-keyboard-backspace"></i>Regresar</button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import { purchaseStatus } from "../constants/constants"
import { UsuarioService } from "../rest"
import OrdenView from "./OrdenView"
export default {
    name: "OrdenApprove",
    data() {
        return {
            orden: {},
        }
    },
    components: {
        OrdenView
    },
    methods: {
        listarPendientes() {
            // Se coloco este código hasta que se decida en que estado deben estar,
            // las ordenes de compra/servicio anteriores para en en la vista approve
            // no cargue todas estas ordenes:
            this.$router.push("/orden")
            // this.$router.push("/orden/approve")
        },
        aprobarOrden() {
            let idUsuario = this.usuario.usu_id
            axios({
                method: "POST",
                url: "/orden/approve",
                headers: { idOrden: this.$route.params.id, idUsuario: idUsuario },
                data: {
                    id_orden_estado: purchaseStatus.APROBACION_GERENCIA.id
                }
            }).then(() => {
                this.$buefy.snackbar.open({
                    message: "Se aprobo la Orden",
                    type: "is-success",
                    position: "is-top",
                    actionText: "OK",
                    indefinite: true,
                    onAction: () => {
                        this.listarPendientes()
                    }
                })
            })
        },
        contableOrden() {
            axios({
                method: "POST",
                url: "/orden/approve",
                headers: { idOrden: this.$route.params.id },
                data: {
                    id_orden_estado: purchaseStatus.EMITIDO.id
                }
            }).then(() => {
                this.$buefy.snackbar.open({
                    message: "Se aprobo la Orden",
                    type: "is-success",
                    position: "is-top",
                    actionText: "OK",
                    indefinite: true,
                    onAction: () => {
                        this.listarPendientes()
                    }
                })
            })
        },
        pagarOrden() {
            axios({
                method: "POST",
                url: "/orden/approve",
                headers: { idOrden: this.$route.params.id },
                data: {
                    id_orden_estado: purchaseStatus.PAGADO.id
                }
            }).then(() => {
                this.$buefy.snackbar.open({
                    message: "Se pago la Orden",
                    type: "is-success",
                    position: "is-top",
                    actionText: "OK",
                    indefinite: true,
                    onAction: () => {
                        this.listarPendientes()
                    }
                })
            })
        },
        loadOrden(orden) {
            this.orden = orden
        }
    },
    computed: {
        usuario() {
            return UsuarioService.getUsuario()
        },
        aprobar() {
            if (
                (this.usuario.roles.indexOf("GERENCIA") > -1
                    || this.usuario.roles.indexOf("ADMINISTRACION") > -1
                    || this.usuario.roles.indexOf("SUPER") > -1
                )
                && this.orden.estado
            ) {
                if (this.orden.estado.id_orden_estado === purchaseStatus.CREADO.id) {
                    return true
                }
            }
            return false
        },
        pagar() {
            if (this.usuario.roles.indexOf("CONTABILIDAD") > -1 && this.orden.estado) {
                if (
                    this.orden.estado.id_orden_estado ===
                    purchaseStatus.EMITIDO.id
                ) {
                    return true
                } else if (
                    this.orden.estado.id_orden_estado ===
                    purchaseStatus.APROBACION_GERENCIA.id
                ) {
                    return false
                }
            }
            return false
        },
        contabilizar() {
            if (this.usuario.roles.indexOf("CONTABILIDAD") > -1 && this.orden.estado) {
                if (
                    this.orden.estado.id_orden_estado === purchaseStatus.EMITIDO.id
                ) {
                    return false
                } else if (
                    this.orden.estado.id_orden_estado === purchaseStatus.APROBACION_GERENCIA.id
                ) {
                    return true
                }
            }
            return false
        }
    }
}
</script>

<style scoped></style>
